'use client'

import React from 'react'

import type { Header as HeaderType } from '@payload-types'

import { CMSLink } from '@/components/link'
import Link from 'next/link'
import { SearchIcon } from 'lucide-react'
import { Separator } from '@/components/ui/separator'

export const HeaderNav: React.FC<{ data: HeaderType }> = ({ data }) => {
  const navItems = data?.nav?.navItems || []

  return (
    <nav className="flex items-center justify-between">
      <div className="flex items-center md:flex-1 overflow-x-auto pb-1 md:pb-0 hide-scrollbar gap-2 ">
        {navItems.map(({ link }, i) => {
          return (
            <div key={i} className="flex items-center">
              <CMSLink
                {...(link as any)}
                appearance="link"
                className="text-sm md:text-base text-foreground whitespace-nowrap px-1 md:px-2 font-bold"
              />
            </div>
          )
        })}
      </div>
      <Link href="/arama" className="text-foreground flex items-center gap-2 ml-2">
        <SearchIcon className="w-4 md:w-5" />
        <span className="text-sm md:text-base text-muted-foreground hidden md:inline">Ara...</span>
      </Link>
    </nav>
  )
}
